import { api } from './client';

export const propostasApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/propostas${qs ? `?${qs}` : ''}`);
  },
  obter: (id) => api.get(`/propostas/${id}`),
  criar: (dados) => api.post('/propostas', dados),
  atualizar: (id, dados) => api.patch(`/propostas/${id}`, dados),
  cancelar: (id) => api.post(`/propostas/${id}/cancelar`),
  excluir: (id) => api.del(`/propostas/${id}`),
  converter: (id) => api.post(`/propostas/${id}/converter`),
  enviarNegociacao: (id) => api.post(`/propostas/${id}/enviar-negociacao`),
  resolverNegociacao: (id, dados) => api.post(`/propostas/${id}/resolver-negociacao`, dados)
};

export const pedidosApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/pedidos${qs ? `?${qs}` : ''}`);
  },
  obter: (id) => api.get(`/pedidos/${id}`),
  cancelar: (id) => api.post(`/pedidos/${id}/cancelar`),
  excluir: (id) => api.del(`/pedidos/${id}`),
  filaSeparacao: () => api.get('/pedidos/fila-separacao'),
  separar: (id) => api.post(`/pedidos/${id}/separar`),
  concluirSeparacao: (id) => api.post(`/pedidos/${id}/concluir-separacao`),
  devolver: (id, observacao) => api.post(`/pedidos/${id}/devolver`, { observacao }),
  retornarAlmoxarifado: (id, observacao) => api.post(`/pedidos/${id}/retornar-almoxarifado`, { observacao }),
  faturar: (id, numero_nota_fiscal, data_emissao) => api.post(`/pedidos/${id}/faturar`, { numero_nota_fiscal, data_emissao }),
  cancelarFaturamento: (id) => api.post(`/pedidos/${id}/cancelar-faturamento`),
  obterDevolucoes: (id) => api.get(`/pedidos/${id}/devolucoes`),
  registrarDevolucao: (id, itens, motivo) => api.post(`/pedidos/${id}/devolucao-cliente`, { itens, motivo })
};
